import { computed, readonly, ref } from 'vue';
import { getCustomSdk } from '@/sdk';

/** Shared by the menu, import buttons and route guard. No GRICS credentials reach this store. */
export function createGricsImportAvailability(fetchAvailability: () => Promise<{ configured: boolean }>) {
  const status = ref<boolean | null>(null);
  let generation = 0;
  let pending: Promise<void> | undefined;

  function reset() {
    generation++;
    pending = undefined;
    status.value = null;
  }

  function refresh(): Promise<void> {
    if (pending) return pending;
    const requestGeneration = generation;
    pending = (async () => {
      try {
        const result = await Promise.resolve().then(fetchAvailability);
        if (generation === requestGeneration) status.value = result.configured === true;
      } catch {
        // A failed readiness check must not expose imports. Navigation can retry it.
        if (generation === requestGeneration) status.value = false;
      } finally {
        if (generation === requestGeneration) pending = undefined;
      }
    })();
    return pending;
  }

  return { status: readonly(status), configured: computed(() => status.value === true), refresh, reset };
}

export const gricsImportAvailability = createGricsImportAvailability(
  () => getCustomSdk().getGricsImportAvailability({ errorHandler: null }),
);
